// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body[data-v-2f4a8bfe]{padding:10px}[data-v-2f4a8bfe] .gt-gantt-content-wrap::-webkit-scrollbar{width:10px;height:10px;opacity:0;background:#fff}[data-v-2f4a8bfe] .gt-gantt-content-wrap{overflow:auto}[data-v-2f4a8bfe] .gt-gantt-content-wrap::-webkit-scrollbar{width:0;height:0}[data-v-2f4a8bfe] .gt-gantt-content-wrap:hover{padding-bottom:1px}[data-v-2f4a8bfe] .gt-gantt-content-wrap:hover::-webkit-scrollbar{width:10px;height:10px}", ""]);
// Exports
module.exports = exports;
